import { animate, timeline } from 'motion';

import { Component } from '@verndale/core';
import Splitting from 'splitting';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      overlay: this.el.querySelector('.card__overlay'),
      text: this.el.querySelector('.card__text'),
      link: this.el.querySelector('a'),
      svg: this.el.querySelector('svg'),
      image: this.el.querySelector('img')
    };

    this.dom.text.lineSplit = Splitting({
      target: this.dom.text,
      by: 'lines'
    });
    this.handleResize();
  }

  addListeners() {
    this.dom.link.addEventListener('mouseover', this.handleHover.bind(this));
    this.dom.link.addEventListener('mouseout', this.handleMouseOut.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    this.isMobile = window.matchMedia('(max-width: 1025px)').matches;
    if (this.visible && this.isMobile) {
      this.handleMouseOut();
    }
  }

  handleHover() {
    if (!this.isMobile) {
      this.timeOverlay = 0.35 + this.el.offsetWidth * 0.0003;

      this.showTime = this.timeOverlay * 0.12;
      this.dom.text.style.visibility = 'visible';

      const showSequence = this.dom.text.lineSplit[0].lines.reduce(
        (sequence, line, index) => {
          const lineSequence = [
            line,
            {
              opacity: [0, 1],
              transform: ['translate(-50px, 0)', 'translate(0, 0)']
            },
            { at: this.showTime * index },
            { duration: this.showTime, delay: this.timeOverlay * 0.6 }
          ];
          sequence.push(lineSequence);
          return sequence;
        },
        []
      );

      const lineSplitEnd = this.dom.text.lineSplit[0].lines.length;

      const svgSequence = [
        this.dom.svg,
        {
          opacity: [0, 1],
          transform: ['translate(-50px, 0)', 'translate(0, 0)']
        },
        { at: this.showTime * lineSplitEnd },
        { duration: this.showTime, delay: this.timeOverlay * 0.6 }
      ];
      showSequence.push(svgSequence);

      animate(
        this.dom.overlay,
        { transform: 'skew(-30deg) scale(2.1, 1)' },
        { duration: this.timeOverlay }
      );

      timeline(showSequence);

      if (this.dom.image)
        animate(this.dom.image, { transform: 'scale(1.25)' }, { duration: 1 });
    }
    this.visible = true;
  }

  handleMouseOut() {
    this.visible = false;
    this.dissappearTime = this.showTime * 0.85;
    const hideSequence = this.dom.text.lineSplit[0].lines.reduce(
      (sequence, line, index) => {
        const lineSequence = [
          line,
          {
            opacity: 0,
            transform: ['translate(0, 0)', 'translate(-50px, 0)']
          },
          { at: this.dissappearTime * index },
          { duration: this.dissappearTime }
        ];
        sequence.push(lineSequence);
        return sequence;
      },
      []
    );

    const lineSplitEnd = this.dom.text.lineSplit[0].lines.length;

    const lineSequence = [
      this.dom.svg,
      {
        opacity: 0,
        transform: ['translate(0, 0)', 'translate(-50px, 0)']
      },
      { at: this.dissappearTime * lineSplitEnd },
      { duration: this.dissappearTime }
    ];

    hideSequence.push(lineSequence);

    timeline(hideSequence).finished.then(() => {
      if (!this.visible) {
        this.dom.text.style.visibility = 'hidden';
      }
    });

    animate(
      this.dom.overlay,
      { transform: 'skew(-30deg) scale(0, 1)' },
      { duration: this.timeOverlay, delay: lineSplitEnd * this.dissappearTime }
    );

    if (this.dom.image)
      animate(
        this.dom.image,
        { transform: 'scale(1)' },
        { duration: this.timeOverlay * 2.6, delay: this.timeOverlay * 0.3 }
      );
  }
}

export default Module;
